import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { Activity, Building2, LayoutDashboard, LogOut, Package, ShieldCheck, Users } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const links = [
  { to: "/app/admin", label: "Vue d’ensemble", icon: LayoutDashboard, end: true },
  { to: "/app/admin/organizations", label: "Organisations", icon: Building2, end: false },
  { to: "/app/admin/users", label: "Utilisateurs", icon: Users, end: true },
  { to: "/app/admin/observability", label: "Observabilité", icon: Activity, end: true },
  { to: "/app/admin/plans", label: "Plans", icon: Package, end: true },
];

export default function PlatformAdminShell() {
  const { organizations, logout } = useAuth();
  const navigate = useNavigate();

  const signOut = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen min-w-0 bg-background" data-testid="platform-admin-shell">
      <header className="border-b border-border bg-card">
        <div className="mx-auto flex w-full max-w-[1280px] flex-wrap items-center justify-between gap-3 px-4 py-4 sm:px-6 lg:px-8">
          <div className="flex min-w-0 items-center gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary text-primary-foreground"><ShieldCheck className="h-5 w-5" aria-hidden="true" /></span>
            <div className="min-w-0">
              <h1 className="font-heading text-lg font-semibold leading-tight sm:text-xl">OneGate Administration</h1>
              <p className="text-xs text-muted-foreground">Administration de la plateforme</p>
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {organizations?.length > 0 && <Button variant="outline" size="sm" asChild><Link to="/app">Retour à mon espace</Link></Button>}
            <Button variant="ghost" size="sm" onClick={signOut}><LogOut className="mr-2 h-4 w-4" aria-hidden="true" />Se déconnecter</Button>
          </div>
        </div>
      </header>
      <div className="border-b border-border bg-card">
        <nav aria-label="Navigation de la plateforme" className="mx-auto grid w-full max-w-[1280px] grid-cols-2 gap-x-1 px-4 sm:flex sm:gap-1 sm:px-6 lg:px-8">
          {links.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} end={end} to={to} className={({ isActive }) => cn(
               "og-focus inline-flex min-w-0 items-center gap-1 border-b-2 px-1.5 py-3 text-xs font-medium transition-colors sm:shrink-0 sm:gap-2 sm:px-3 sm:text-sm",
              isActive ? "border-primary text-primary" : "border-transparent text-muted-foreground hover:text-foreground",
            )}>
               <Icon className="h-3.5 w-3.5 sm:h-4 sm:w-4" aria-hidden="true" />{label}
            </NavLink>
          ))}
        </nav>
      </div>
      <main className="mx-auto w-full max-w-[1280px] min-w-0 px-4 py-6 sm:px-6 lg:px-8 lg:py-8">
        <Outlet />
      </main>
    </div>
  );
}